var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "操作用户账号" } },
                        [
                          _c("j-input", {
                            attrs: { placeholder: "请输入操作用户账号" },
                            model: {
                              value: _vm.queryParam.userid,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "userid", $$v)
                              },
                              expression: "queryParam.userid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "操作用户名称" } },
                        [
                          _c("j-input", {
                            attrs: { placeholder: "请输入操作用户名称" },
                            model: {
                              value: _vm.queryParam.username,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "username", $$v)
                              },
                              expression: "queryParam.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "问题" } },
                        [
                          _c("j-input", {
                            attrs: { placeholder: "请输入问题" },
                            model: {
                              value: _vm.queryParam.query,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "query", $$v)
                              },
                              expression: "queryParam.query"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "回答" } },
                        [
                          _c("j-input", {
                            attrs: { placeholder: "请输入回答" },
                            model: {
                              value: _vm.queryParam.answer,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "answer", $$v)
                              },
                              expression: "queryParam.answer"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 10, lg: 11, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("j-date", {
                            staticClass: "query-group-cust",
                            attrs: {
                              placeholder: "请选择开始日期",
                              "show-time": true,
                              "date-format": "YYYY-MM-DD HH:mm:ss"
                            },
                            model: {
                              value: _vm.queryParam.createTime_begin,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.queryParam,
                                  "createTime_begin",
                                  $$v
                                )
                              },
                              expression: "queryParam.createTime_begin"
                            }
                          }),
                          _c("span", { staticClass: "query-group-split-cust" }),
                          _c("j-date", {
                            staticClass: "query-group-cust",
                            attrs: {
                              placeholder: "请选择结束日期",
                              "show-time": true,
                              "date-format": "YYYY-MM-DD HH:mm:ss"
                            },
                            model: {
                              value: _vm.queryParam.createTime_end,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "createTime_end", $$v)
                              },
                              expression: "queryParam.createTime_end"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("emp_aiagent_log")
                }
              }
            },
            [_vm._v("导出")]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "htmlSlot",
                fn: function(text) {
                  return [_c("div", { domProps: { innerHTML: _vm._s(text) } })]
                }
              },
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic"
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "25px",
                            alt: ""
                          }
                        })
                  ]
                }
              },
              {
                key: "fileSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              icon: "download",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(text)
                              }
                            }
                          },
                          [_vm._v("\n            下载\n          ")]
                        )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      ),
                      record.userid
                        ? [
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openChatListModal(record)
                                  }
                                }
                              },
                              [_vm._v("对话列表")]
                            )
                          ]
                        : _vm._e(),
                      record.conversationId
                        ? [
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openChatDetailModal(record)
                                  }
                                }
                              },
                              [_vm._v("对话详情")]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }
              },
              {
                key: "querySlot",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: record.query,
                          placement: "topLeft",
                          disabled: false
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              !text
                                ? ""
                                : text.length > 30
                                ? text.substr(0, 30) + "..."
                                : text
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              },
              {
                key: "answerSlot",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: record.answer,
                          placement: "topLeft",
                          disabled: false
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              !text
                                ? ""
                                : text.length > 50
                                ? text.substr(0, 50) + "..."
                                : text
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("emp-aiagent-log-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "对话列表",
            visible: _vm.chatListModalVisible,
            footer: null,
            width: "80%",
            zIndex: "1000"
          },
          on: { cancel: _vm.closeChatListModal }
        },
        [
          _vm.chatListModalVisible
            ? _c("chat-list-modal", {
                attrs: {
                  visible: _vm.chatListModalVisible,
                  user: _vm.currentRecord && _vm.currentRecord.userid
                },
                on: {
                  close: _vm.closeChatListModal,
                  "view-conversation": _vm.handleViewConversation
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "对话详情",
            visible: _vm.chatDetailModalVisible,
            footer: null,
            width: "50%",
            zIndex: "1001"
          },
          on: { cancel: _vm.closeChatDetailModal }
        },
        [
          _vm.chatDetailModalVisible
            ? _c("chat-detail-modal", {
                attrs: {
                  visible: _vm.chatDetailModalVisible,
                  conversationId:
                    _vm.currentRecord && _vm.currentRecord.conversationId,
                  user: _vm.currentRecord && _vm.currentRecord.userid
                },
                on: { close: _vm.closeChatDetailModal }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }